import api, { request } from '../../../../api';
import { IStore } from '../../../index';
import { IAdminFlight } from '../../eventFlights/store';

export const createFlight = async (state: IStore, clubId: number, flight: IAdminFlight) => {
  const response = await request.post(api.admin.flights(clubId, flight.event), flight);

  if (response.error) {
    const err =
      (response.error.statusText && response.error.statusText.join('. ')) || response.error.status;
    return { errors: { events: { msg: 'Error Creating the flight: ' + err } } };
  }

  return {
    adminEvents: {
      all: {
        ...state.adminEvents.all,
        [response.event]: {
          ...state.adminEvents[response.event],
          flights: [...state.adminEvents[response.event].flights, response]
        }
      },
      current: {
        ...state.adminEvents[response.event],
        flights: [...state.adminEvents[response.event].flights, response]
      },
      [response.event]: {
        ...state.adminEvents[response.event],
        flights: [...state.adminEvents[response.event].flights, response]
      }
    }
  };
};
